import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "full-opera" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "el-icon-minus" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: "full-image",
    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
  }, [
    _createVNode("img", {
      src: _ctx.picAddress,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imgClose($event))),
      style: { transform: ' translateY(-50%) scale(' + _ctx.scale + ')' }
    }, null, 12, ["src"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.changeScale(0.1)), ["stop"]))
      }, [
        _hoisted_2
      ]),
      _createVNode("div", {
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.changeScale(-0.1)), ["stop"]))
      }, [
        _hoisted_3
      ])
    ])
  ]))
}